import { buildCues } from "./build.js";
const GAP = 0.083;
function preset(p) {
    return Object.freeze({
        ...p,
        rules: Object.freeze({ ...p.rules }),
        safeArea: Object.freeze({ ...p.safeArea }),
        formats: Object.freeze([...p.formats]),
        burnIn: !p.formats.includes("srt") && !p.formats.includes("vtt"),
    });
}
const sidecar = (id, label, labelEn, safeArea) => preset({
    id,
    label,
    labelEn,
    aspect: "16:9",
    rules: { maxCharsPerLine: 42, maxLines: 2, maxCps: 17, minDuration: 0.833, maxDuration: 7, minGap: GAP },
    safeArea,
    formats: ["srt", "burn"],
    fontScale: 0.05,
});
const vertical = (id, label, labelEn, safeArea, formats, fontScale) => preset({
    id,
    label,
    labelEn,
    aspect: "9:16",
    rules: { maxCharsPerLine: 25, maxLines: 2, maxCps: 20, minDuration: 0.7, maxDuration: 4, minGap: GAP },
    safeArea,
    formats,
    fontScale,
});
export const CAPTION_PRESETS = Object.freeze([
    preset({
        id: "youtube",
        label: "YouTube",
        labelEn: "YouTube",
        aspect: "16:9",
        rules: { maxCharsPerLine: 42, maxLines: 2, maxCps: 17, minDuration: 1, maxDuration: 6, minGap: GAP },
        safeArea: { bottomPct: 10, topPct: 5, sidePct: 5 },
        formats: ["srt", "vtt", "burn"],
        fontScale: 0.05,
    }),
    vertical("youtube-shorts", "YouTube Shorts", "YouTube Shorts", { bottomPct: 20, topPct: 8, sidePct: 6 }, ["srt", "vtt", "burn"], 0.032),
    vertical("tiktok", "TikTok", "TikTok", { bottomPct: 25, topPct: 7, sidePct: 13 }, ["burn"], 0.03),
    vertical("instagram-reels", "Instagram Reels", "Instagram Reels", { bottomPct: 35, topPct: 14, sidePct: 6 }, ["burn"], 0.036),
    preset({
        id: "instagram",
        label: "Instagram (postim)",
        labelEn: "Instagram (feed)",
        aspect: "4:5",
        rules: { maxCharsPerLine: 32, maxLines: 2, maxCps: 17, minDuration: 0.833, maxDuration: 5, minGap: GAP },
        safeArea: { bottomPct: 12, topPct: 5, sidePct: 6 },
        formats: ["burn"],
        fontScale: 0.04,
    }),
    sidecar("facebook", "Facebook", "Facebook", { bottomPct: 10, topPct: 5, sidePct: 5 }),
    sidecar("linkedin", "LinkedIn", "LinkedIn", { bottomPct: 10, topPct: 5, sidePct: 5 }),
    sidecar("x", "X", "X", { bottomPct: 10, topPct: 5, sidePct: 5 }),
    preset({
        id: "broadcast",
        label: "Televizion / lajme",
        labelEn: "Broadcast / news",
        aspect: "16:9",
        rules: { maxCharsPerLine: 37, maxLines: 2, maxCps: 16, minDuration: 1, maxDuration: 7, minGap: 0.08 },
        safeArea: { bottomPct: 5, topPct: 5, sidePct: 12.5 },
        formats: ["srt", "vtt"],
        fontScale: 0.042,
    }),
]);
export const CAPTION_PRESET_IDS = CAPTION_PRESETS.map((p) => p.id);
export function isCaptionPresetId(id) {
    return typeof id === "string" && CAPTION_PRESETS.some((p) => p.id === id);
}
export function getCaptionPreset(id) {
    const found = CAPTION_PRESETS.find((p) => p.id === id);
    if (!found)
        throw new Error(`Unknown caption preset: ${String(id)}`);
    return found;
}
/** Cues built from the transcript's words with the preset's rules (ignores edited captions). */
export function presetCues(t, presetId) {
    return buildCues(t, getCaptionPreset(presetId).rules);
}
